import ImageZoom from './image-zoom/ImageZoom.vue';
import Select2 from './select2/Select2.vue';

export default {
  ImageZoom: ImageZoom,
  Select2: Select2
};


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/components.js
// module id = llLr
// module chunks = 4